/* eslint-disable import/prefer-default-export -- Named export required for barrel exports */

import { Spinner } from "@nextui-org/react";
import type { ReactNode } from "react";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import PersonasLoggedIn from "./PersonasLoggedIn";

const Personas = () => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  let pageContent: ReactNode;
  if (isAuthLoading) {
    pageContent = <Spinner />;
  } else if (!isAuthenticated) {
    pageContent = <AnonymousMarketing datakey="persona" />;
  } else {
    pageContent = <PersonasLoggedIn />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="myPersonas" data-testid="Personas-PageStaticMetaTags" />
      {pageContent}
    </>
  );
}
export default Personas;